import React from "react";
import { Link } from "react-router-dom";

function AlertBanner(props) {
  return (
    <div
      className={`alert alert-${props.alert.alertType} alert-dismissible alert-banner fade show`}
      role="alert"
    >
      <div className="container">
        <button
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        
          {props.alert.showIcon && (
          <span className="alert-level" style={{padding:0}}>
            <span className="ca-gov-icon-important" aria-hidden="true"></span>
          </span>
          )}
          {props.alert.alertLevel}
        
        <span className="alert-text">{props.alert.alertText}</span>
        {props.alert.showButton && (
          <Link
            to={props.alert.link}
            className="alert-link btn btn-default btn-xs"
          >
            {props.alert.buttonText}
          </Link>
        )}
      </div>
    </div>
  );
}

export default AlertBanner;
